<template>
    <InventoryHeaderTab />

    <div class="mt-3 gridtop">
        <div class="d-flex justify-content-between  my-3">
            <div class="mt-2 fw-bold" style="font-size:20px">
                <router-link to="/all-stock-adjustment">
                    <font-awesome-icon class="arrowradius ms-1" prefix="far" icon="angle-left" />
                </router-link>
                {{store_adjustment?.batch_code}}
            </div>
    
            <PrintButtonHeader :title="'Invoice-'+store_adjustment?.batch_code" :urlA4="'/view-stock-adjustment/'" :url58mm="'/print58mm-stock-Adjustment/'" :url80mm="'/print80mm-stock-Adjustment/'" :currentUrl="'Print 80mm Stock Adjustment'" :data="store_adjustment" :type="'Stock Adjustment'"/>

        </div>
        <div class="bg-white print d-flex justify-content-center rounded-lg mt-3 mb-3 px-4 py-3 cardpadding"
            style="overflow-x: auto;">
            <div class="printborder">
                <div class="p-5 sales_invoice" id="printMe">

                    <div>Date: {{dateTime(store_adjustment?.date) + ', ' + timeConvert(store_adjustment?.time)}}</div>
                    <div>Store: {{store_adjustment?.store?.store_name}}</div>
                    <div>Adjustment No: {{store_adjustment?.batch_code}}</div>
                    <div>Adjusted By: {{store_adjustment?.user?.fullname}}</div>

                    <div class="printdottedborder mt-3"></div>
                    <div class="printdottedborder mt-1 mb-3"></div>
                    <hr class="solid_line" />

                    <div v-for="item in adjustment_items" :key="item.id">
                        <div class="d-flex justify-content-between">
                            <div>{{item?.product?.bar_code}}</div>
                            <div v-if="item?.variant">({{  item?.variant?.variant_name }})</div>
                            <div v-else>({{  item?.product?.unit_of_measurement }})</div>

                        </div>
                        <div class="d-flex justify-content-between">
                            <div>{{item?.product?.product_name}}</div>
                                <div>
                                    {{item.adjustment_type == 1 ? `${'Increased by ' + item?.quantity}` : `${'Decreased by ' + item?.quantity}`}}    
                                </div>
                        </div>
                        <hr class="solid_line" />
                    </div>

                    <div class="printdottedborder mt-3"></div>
                    <div class="printdottedborder mt-1 mb-3"></div>
                    <div class="mt-4">Powered by InventFlux</div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InventoryHeaderTab from './component/inventoryheadertab.vue'
// import JQuery from 'jquery'
import axios from "axios";
import { reusableMixin } from '../../../lib/reusableMixin';

export default {
    components: {
        InventoryHeaderTab
    },
    mixins: [reusableMixin],

    data() {
        return {
            store_adjustment: null,
            adjustment_items: []
        }
    },

    methods: {
        
        getStockAdjustment() {
            axios.get(`/inventory/store-adjustment/${this.$route.params.id}`).then((response) => {
                this.store_adjustment = response.data.data
                this.adjustment_items = response.data.data.adjustment_item

            }).catch(() => {
                this.toast.error("Oops, Something went wrong")
            })
        },
    },

    computed: {
        totalPrice() {

        let total = this.adjustment_items.reduce((a, b) => {
                return a + parseFloat(b.total_price);
            }, 0);
            return (total);
        }
    },

    created() {
        this.getStockAdjustment()
    }

}
</script>
